import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MeetingProvider,
  MeetingConsumer,
  useMeeting,
  useParticipant,
} from "@videosdk.live/react-sdk";
import ReactPlayer from "react-player";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import JoinScreen from "./JoinScreen";
import MeetingView from "./MeetingView";
import { getProfileData } from "../../Redux/action/MasterAction";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import FeedbackForm from "../FeedbackForm/FeedbackForm";
const MeetingFrame = () => {
  const { b64id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const authToken = process.env.REACT_APP_VIDEO_SDK_TOKEN
  const Token = location?.state?.authToken
  const endTime = location?.state?.end_time
  const tutor_id = location?.state?.tutor_id
  const student_id = location?.state?.student_id
  const session_id = location?.state?.session_id
  const booked_id = location?.state?.booked_id
  const meeting_session_id = location?.state?.meeting_session_id

  const [meetingId, setMeetingId] = useState(location?.state?.meetingLink)
  // const meetingId = location?.state?.meetingLink
  useEffect(() => {
    if (location?.state) {

      setMeetingId(location?.state?.meetingLink)
      // localStorage.setItem('meetinId', location?.state?.meetingLink)
    }
    else {

      navigate(-1)
    }
  }, [])
  // const meetingId = localStorage.getItem('meetinId')






  useEffect(() => {
    if (Token) {
      dispatch(getProfileData(Token))
    }
  }, [location, Token]);

  const {
    loadingProfileDataListApi,
    ProfileDataListApiData,
    ProfileDataListApiError,

  } = useSelector(state => state?.MasterReducer);

  const onMeetingLeave = () => {
    setMeetingId(null)

    if (ProfileDataListApiData?.data?.user_type == 'student') {
      navigate('/student/reviews', {
        state: {
          tutor_id: tutor_id,
          student_id: student_id,
          session_id: session_id,
          booked_id: booked_id
        }
      })
    }
    else {
      navigate(-1)
    }


  };

  useEffect(() => {
    if (!authToken || !meetingId) {
      navigate(-1); // Navigate to the previous page
    }
  }, [authToken, meetingId, navigate]);

  return authToken && meetingId ? (
    <>
      <MeetingProvider
        config={{
          meetingId,
          micEnabled: true,
          webcamEnabled: true,
          name: ProfileDataListApiData?.data?.name,
          metaData: {
            user_type: ProfileDataListApiData?.data?.user_type, 
            user_name: ProfileDataListApiData?.data?.name, 
          },
        }}
        token={authToken}
      >
        <MeetingView meetingId={meetingId} onMeetingLeave={onMeetingLeave} user_type={ProfileDataListApiData?.data?.user_type} user_name={ProfileDataListApiData?.data?.name} endTime={endTime} location={location?.state} />
      </MeetingProvider></>
  ) : (
    <div className="h-100 bg-dark"> <h1></h1></div>

  );
};

export default MeetingFrame;
